import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { CreateTableForUpload } from "../table/CreateTableForUpload";
import leaveTypeService from "../../../../v2/services/leaveTypeService";

export function UploadLeaveForm({ isOpen,
  onClose,
  uploadEmployeeLeaveInformations_temp,
  setUploadEmployeeLeaveInformations_temp,
  handleFileUpload,
  handleFinalFileUploadLeave }
) {
  const handleClose = () => {
    onClose();
    setFiles("");
    setUploadEmployeeLeaveInformations_temp([]);
  };

  const [files, setFiles] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [hasNoError, setHasNoError] = useState(false);

  useEffect(() => {
    if (uploadEmployeeLeaveInformations_temp.length > 0) {
      const _errorData = uploadEmployeeLeaveInformations_temp.filter(i => i.errors.length > 0)

      if (_errorData.length <= 0) {
        setHasNoError(true)
      } else {
        setHasNoError(false)
      }
    }
  }, [uploadEmployeeLeaveInformations_temp])

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById('fileInput').value = '';
    setUploadEmployeeLeaveInformations_temp([]);
  };

  useEffect(() => {
    if (currentFiles !== files) {
      setCurrentFiles(files)
      handleFileUpload(files);
    }
  }, [files, handleFileUpload, currentFiles])

  const submit = (e) => {
    handleFinalFileUploadLeave(uploadEmployeeLeaveInformations_temp);
    handleClose();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [dynamicColumns, setDynamicColumns] = useState({ headers: [], accessors: [] });

  useEffect(() => {
    const fetchConfig = async () => {
      const res = await leaveTypeService.getActive();
      const leaves = res.data || [];

      const h = ["Employee Id", "Employee Name"];
      const a = ["employeeId", "fullName"];

      leaves.forEach(l => {
        h.push(`Total ${l.description}`, `${l.description} Remaining`);
        a.push(`total_${l.id}`, `remaining_${l.id}`);
      });

      h.push("Error");
      a.push("errors");
      setDynamicColumns({ headers: h, accessors: a });
    };
    if (isOpen) fetchConfig();
  }, [isOpen]);

  // REPLACED hardcoded arrays with dynamic state
  const header = dynamicColumns.headers;
  const accessor = dynamicColumns.accessors;

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Update Employee's Leave Information"}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>

            <div className="popUp-body user-template-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

            </div>

            <div>
              <label htmlFor="fileInput" className='browse'>Browse...</label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: 'none' }}
              />
              <div
                id='drop-files-here'
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: '2px dashed #ccc',
                  borderRadius: '5px',
                  padding: '20px',
                  marginTop: '10px',
                  textAlign: 'center',
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div className="buttons row" style={{ display: "flex", justifyContent: "end" }}>
                    <button id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}>
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && dynamicColumns.headers.length > 0 && (
              <>
                {hasNoError ? (
                  <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white" }}>
                    Data is valid.
                  </div>
                ) : (
                  <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white" }}>
                    Cannot upload with error.
                  </div>
                )}
                <div className='employeesTab-tab upload-preview-tab' style={{ marginTop: "10px" }}>
                  <div id="container1 table-uploads" className="employeesTab-table container">
                    <CreateTableForUpload
                      dataList={uploadEmployeeLeaveInformations_temp}
                      dataHeader={dynamicColumns.headers} // Use state directly
                      dataAccessor={dynamicColumns.accessors} // Use state directly
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
                <div className="buttons row" style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}>
                  {hasNoError && <button id="add-family"
                    className="save row"
                    onClick={(e) => submit(e)}
                    style={{ marginRight: "5px" }}>
                    UPLOAD
                  </button>}
                  <button id="add-family"
                    className="cancel row"
                    style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}
                    onClick={() => handleClose()}>
                    CANCEL
                  </button>
                </div>
              </>
            )
            }


          </div>
        )}
      </div>
    </>
  );
}